import { companyInfo } from "@/mocks/homeData";

export default function AboutSection() {
  return (
    <section id="about" className="relative w-full bg-white py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="animate-on-scroll text-center mb-12 md:mb-16">
            <p className="text-sky-500 text-sm font-semibold tracking-wider uppercase mb-3">
              About Us
            </p>
            <h2 className="text-2xl md:text-4xl font-bold text-navy-900">
              회사 소개
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
            <div className="animate-on-scroll delay-100">
              <div className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-navy-50">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20interior%20with%20diverse%20international%20team%20meeting%20around%20a%20bright%20conference%20table%2C%20warm%20natural%20lighting%20from%20large%20windows%2C%20professional%20business%20atmosphere%20with%20subtle%20Korean%20cultural%20elements%20on%20wall%2C%20navy%20blue%20and%20white%20color%20scheme%2C%20clean%20contemporary%20design%20photography&width=800&height=600&seq=about1&orientation=landscape"
                  alt="회사 소개 이미지"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="animate-on-scroll delay-200 space-y-6">
              <h3 className="text-xl md:text-2xl font-bold text-navy-900 leading-snug">
                한국의 교육·문화·체육 콘텐츠를 기반으로
                <br />
                <span className="text-sky-600">글로벌 교류 플랫폼</span>으로 성장
              </h3>

              <p className="text-navy-600 text-sm md:text-base leading-relaxed">
                (주)한국문화체육진흥원은 외국인 유학생의 한국 대학 입학을 지원하고,
                문화행사·체육교류 사업을 운영하는 글로벌 교류 플랫폼 기업입니다.
                베트남, 필리핀, 몽골 등 해외 학생들의 한남대학교 입학 알선부터
                비자·서류 지원, 생활 정착 프로그램까지 체계적으로 지원합니다.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
                <div className="bg-navy-50 rounded-xl p-4 md:p-5">
                  <div className="w-8 h-8 flex items-center justify-center mb-2">
                    <i className="ri-calendar-check-line text-sky-500 text-lg" />
                  </div>
                  <p className="text-xs text-navy-400 mb-1">설립일</p>
                  <p className="text-sm font-semibold text-navy-900">{companyInfo.founded}</p>
                </div>

                <div className="bg-navy-50 rounded-xl p-4 md:p-5">
                  <div className="w-8 h-8 flex items-center justify-center mb-2">
                    <i className="ri-user-3-line text-sky-500 text-lg" />
                  </div>
                  <p className="text-xs text-navy-400 mb-1">대표자</p>
                  <p className="text-sm font-semibold text-navy-900">{companyInfo.ceos}</p>
                </div>

                <div className="bg-navy-50 rounded-xl p-4 md:p-5">
                  <div className="w-8 h-8 flex items-center justify-center mb-2">
                    <i className="ri-map-pin-line text-sky-500 text-lg" />
                  </div>
                  <p className="text-xs text-navy-400 mb-1">소재지</p>
                  <p className="text-sm font-semibold text-navy-900 leading-tight">{companyInfo.address}</p>
                </div>

                <div className="bg-navy-50 rounded-xl p-4 md:p-5">
                  <div className="w-8 h-8 flex items-center justify-center mb-2">
                    <i className="ri-file-list-3-line text-sky-500 text-lg" />
                  </div>
                  <p className="text-xs text-navy-400 mb-1">사업자등록번호</p>
                  <p className="text-sm font-semibold text-navy-900">{companyInfo.regNumber}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}